export const branchInfo = {
  designation: null,
  email: null,
  fullName: null,
  landlines: [],
  mobiles: [],
  business_name: null,
  trading_name: null,
  address: null,
  gst: null,
  charges: null,
  notes: null,
  pan: null,
  place_name: null,
  website: null,
  aadhar: null,
  materials: [],
  industry: null,
  place_latitude: null,
  place_longitude: null,
  place_id: null,
  place_reference: null,
  map_url: null,
  pincode: null,
}
export const resetBranchInfo = { ...branchInfo }

export const usersBranchesColumns = [
  {
    column_name: 'ID',
    column_value: 'id',
  },
  {
    column_name: 'Business Name',
    column_value: 'business_name',
  },
  {
    column_name: 'Trading Name',
    column_value: 'trading_name',
  },
  {
    column_name: 'Name',
    column_value: 'full_name',
  },
  {
    column_name: 'Designation',
    column_value: 'designation',
  },
  {
    column_name: 'Area',
    column_value: '',
  },
  {
    column_name: 'Mobile No.',
    column_value: 'mobiles',
  },
  {
    column_name: 'Business GST no.',
    column_value: 'gst',
  },
  {
    column_name: 'Hamali Charges',
    column_value: '',
  },
  {
    column_name: 'Landline No.',
    column_value: 'landlines',
  },
  {
    column_name: 'PAN No.',
    column_value: 'pan',
  },
  {
    column_name: 'Doc Verification',
    column_value: 'is_docs_verified',
  },
  {
    column_name: 'Email Address',
    column_value: 'email',
  },
  {
    column_name: 'Website',
    column_value: '',
  },
  {
    column_name: 'Status',
    column_value: 'is_active',
  },
  {
    column_name: 'Created Timestamp',
    column_value: 'created_at',
  },
  {
    column_name: 'Updated Timestamp',
    column_value: 'updated_at',
  },
  {
    column_name: '',
    column_value: '',
  },
]

export const branchSearchFields: any = reactive({
  id: '',
  businessName: '',
  trading_name: '',
  fullname: '',
  designation: '',
  place_name: '',
  mobiles: '',
  charges: '',
  landlines: '',
  email: '',
  fullName: '',
  gst: '',
  website: '',
  is_docs_verified: '',
  is_active: '',
  pan: '',
})

export const resetBranchInfoFields = { ...branchSearchFields }
